import axiosInstance, { ApiResponse } from './axios'
import { getEnvIMbaseURL } from '@/utils/env'
import { Conversation, Message } from '@/utils/constant'

const host = getEnvIMbaseURL()

export type FetchChatListResponse = ApiResponse<{
  /**
   * 会话列表
   */
  conversations: Conversation[]
  /**
   * 总数
   */
  totalCount: number
}>

export type FetchMessageListResponse = ApiResponse<{
  /**
   * 消息列表
   */
  messages: Message[]
}>

/**
 * 获取历史会话列表
 * @param {*} params
 * @returns
 */
export function fetchChatList(params = {}) {
  return axiosInstance.post<FetchChatListResponse>(`${host}/voghion-im/conversation/history`, params, {
    retry: 3
  })
}

/**
 * 获取消息列表
 * @param {*} params
 * @returns
 */
export function fetchMessageList(params = {}) {
  return axiosInstance.post<FetchMessageListResponse>(`${host}/voghion-im/conversation/details`, params, {
    retry: 3
  })
}
